<template >
  <v-layout align-start>
    <v-flex>
      <!-- Tabs-->
      <div v-if="TablaVisible">
        <template>
          <v-form>
            <v-container grid-list-sm class="pa-4 white">
              <v-row>
                <v-col cols="12" md="12">
                  <v-alert type="success" class="subtitle-2 text-center" color="primary">ALTA DE DOCUMENTOS</v-alert>
                </v-col>
                <v-col cols="12" md="12">
                  <v-alert type="success" v-if="alertavisible == 1" class="subtitle-2 text-center" color="primary" dark
                    dense>
                    <div class="text title font-weight-black" v-text="alerta"></div>
                  </v-alert>
                  <v-alert type="error" v-if="alertavisible == 0" class="subtitle-2 text-center">
                    <div class="text" v-text="alerta"></div>
                  </v-alert>
                  <div class="text subtitle-2 text-center" v-text="alerta" v-if="alertavisible == 2"></div>
                </v-col>

                 <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="empresaid" :items="empresaselect" label="Nombre de la Empresa"
                    v-on:change="selectempresanombre()" outlined></v-select>
                </v-col>

                 <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="carpetaid" :items="carpetaselect" label="Nombre de la Carpeta"
                    v-on:change="selectcarpetanombre()" outlined></v-select>
                </v-col>

                   <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="expedienteid" :items="expedienteselect" label="Nombre de la Documento"
                    v-on:change="selectexpedientenombre()" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                   <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="documentonombre" label="Nombre del Documento" required outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="documentofolio" label="Folio o Factura" required outlined></v-text-field>
                </v-col>

                 <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="documentofechacarga" label="Fecha del Flete" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="documentofechacarga" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="12">
                  <v-textarea v-model="documentoobservacion" outlined name="input-7-7" label="Observacion del Documento"
                    :readonly="vsdocumentoobservacion == 1"></v-textarea>
                </v-col>
              </v-row>

              <template>
                <div>
                  <v-col cols="12" md="12" align="center" justify="center" v-if="guardarvisible == 1">
                    <label>
                      Carga El Documento
                      <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                        v-on:change="handleFileUpload()" />
                    </label>
                  </v-col>
                  <div align="center" justify="center">
                    <div class="my-2">
                      <v-btn color="secondary" @click="close">Cancelar</v-btn>
                      <v-btn color="primary" @click="guardar" v-if="guardarvisible == 1">Guardar</v-btn>
                    </div>

                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="12" md="12" v-show="valida">
                      <v-row class="red--text" v-for="v in validamensaje" :key="v" v-text="v"></v-row>
                    </v-col>
                  </div>

                  <v-card max-width="1200" class="mx-auto">
                    <v-list-item>
                      <v-list-item-avatar color="grey"></v-list-item-avatar>
                      <v-list-item-content align="center" justify="center">
                        <v-list-item-title class="headline">Visualizando el Documento</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                      <v-img :src="imagePreview"></v-img>
                    </v-col>

                    <v-col cols="12" md="12" v-if="imagenopdf == 2">
                      <iframe :src="pdfPreview" width="100%" height="1020px" class="embed-responsive-item"></iframe>
                    </v-col>

                    <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea el
                      Correcto</v-card-text>
                  </v-card>
                </div>
              </template>
            </v-container>
          </v-form>
        </template>
      </div>

      <!-- Cierre Tabs-->

      <v-data-table :headers="headers" :items="documentos" :search="search" class="elevation-1" v-if="TablaVisible == 0">
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Documentos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line
              hide-details></v-text-field>
            <v-btn v-if="TablaVisible == 0" @click="listar()" color="primary" dark class="mb-2">Buscar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" v-if="TablaVisible == 0" @click="mostrarNuevo">Nuevo</v-btn>

            <v-dialog v-model="adModal" max-width="800">
              <v-card class="mx-auto">
                <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                  <v-img class="white--text align-end" :src="verdocumento"></v-img>
                </v-col>

                <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 2">
                  <iframe :src="verdocumento" width="100%" height="1020px" class="embed-responsive-item"></iframe>
                </v-col>
            
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small class="mr-2" @click="editItem(item)" v-on="on">remove_red_eye</v-icon>
            </template>
            <span>Ver Documentos Capturado</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small class="mr-2" @click="ActivarDesactivarMostrar(2, item)" v-on="on">check</v-icon>
            </template>
            <span>Ver Imagen</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon v-if="item.documentoestatus == 1" small class="mr-2" @click="activar(item)"
                v-on="on">check_circle</v-icon>
            </template>
            <span>Activar Documento</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon v-if="item.documentoestatus == 1" small class="mr-2" @click="eliminar(item)"
                v-on="on">delete_forever</v-icon>
            </template>
            <span>Eliminar Documento</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon v-if="item.documentoestatus == 1 || item.documentoestatus == 3" small class="mr-2" @click="abrirDocumentoConAxios(item)"
                v-on="on">picture_as_pdf</v-icon>
            </template>
            <span>Ver Documento</span>
          </v-tooltip>

        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.documentofecha="{ item }">
          <p>{{ getHumanDate(item.documentofecha) }}</p>
        </template>
        <template v-slot:item.documentoestatus="{ item }">
          <v-chip :color="getColor(item.documentoestatus)" dark v-if="item.documentoestatus == 13">ACTIVO</v-chip>
          <v-chip :color="getColor(item.documentoestatus)" dark v-if="item.documentoestatus == 14">SUSPENDIDO</v-chip>
          <v-chip :color="getColor(item.documentoestatus)" dark v-if="item.documentoestatus == 1">SOLICITUD</v-chip>
          <v-chip :color="getColor(item.documentoestatus)" dark v-if="item.documentoestatus == 12">CANCELADO</v-chip>
        </template>
      </v-data-table>



    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";

export default {
  data() {
    return {
      // Variable de Servidor Envia Fotos
      VUE_APP_CLOUDINARY_URL: process.env.VUE_APP_CLOUDINARY_URL_ROOT,
      // Modal de Fechas
      //documentofecha: new Date().toISOString().substr(0, 10),
      modal: false,
      // Selects

      // Datos
      socioid: "",
      documentofecha: "",
      documentohora: "",
      tipodocumentoid: "",
      documentoobservacion: "",
      tipodocumentonombre: "",
      socionombrecompleto: "",
      imagePreview: "",
      alerta: null,
      alertavisible: 2,
      pdfPreview: "",
      imagenopdf: 0,
      extencion: 0,
      guardarvisible: 1,
      tipocuentaid: "",
      cuentaid: "",
      diaid: "",
      mesid: "",
      añoid: "",
      // Selects
      tipocuentaselect: [
        { text: "NO APLICA", value: 1 },
        { text: "SOLICITUD DE CRÉDITO", value: 2 },
        { text: "CUENTA DE AHORRO", value: 3 },
        { text: "INVERSIONES", value: 4 },
        { text: "CONTRATOS DE CRÉDITO", value: 5 }
      ],
      cuentaselect: [],
    
      // Variable Socio
      documentos: [],
      dialog: false,
      TablaVisible: 0,
      headers: [
        { text: "Accion", value: "action", sortable: false },
        { text: "Id", value: "documentoid" },
        { text: "Empresa", value: "empresanombre" },
        { text: "Carpera", value: "carpetanombre" },
        { text: "Nombre", value: "documentonombre" },
        { text: "Fecha", value: "documentofecha", sortable: false },
        { text: "Hora", value: "documentohora", sortable: false },
        { text: "Estatus", value: "documentoestatus", sortable: false }
      ],
      search: "",
      // Campos
      imagen: "",
      //
      editedIndex: -1,

      //Declaracion de varaibles
      id: "",
      nombre: "",
      descripcion: "",
      // Declara variables de Validacion
      valida: 0,
      validamensaje: [],
      // Declara Varaiables para ctivar o desactivar categorias
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      dismissSecs: 5,
      dismissCountDown: 0,

      vsbuscarsocio: 1,
      vssocioid: 1,
      vstipodocumentoid: 1,
      vstipocuentaid: 1,
      vscuentaid: 1,
      vsdiaid: 1,
      vsmesid: 1,
      vsañoid: 1,
      vsdocumentoobservacion: 1,
      empresaid: "",
      empresaselect: [],
      carpetaid: "",
      carpetaselect: [],
      documentonombre: "",
      url:process.env.VUE_APP_CLOUDINARY_URL_DOC, 
      verdocumento:"",
      expedienteid:"",
      expedienteselect:[],
      combustibleselect: [],
      combustibleid:10,
      documentofechacarga: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      modal: false,
      modal1: false,
      menu: false,
      menu1: false,
      modal: false,
      documentofolio:"",
       modal: false,
      modal1: false,
     
      servicionombre:"",
      
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Tasa" : "Actualizando Tasa";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.listar();
    this.selectempresa();
    this.selectcarpeta();
    this.selectgasolinatipo();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    // Formato de Fecha
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    mostrarNuevo() {
      this.TablaVisible = 1;
      this.limpiar();
    },
    ocultarNuevo() {
      this.TablaVisible = 0;
      this.limpiar();
    },

    selectexpedientenombre(){
       this.documentonombre = event.target.textContent;
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "yellow";
      if (socioestatus == 3) return "#DA0707";
    },

    prende() {
      this.vsbuscarsocio = 0;
      this.vssocioid = 0;
      this.vstipodocumentoid = 0;
      this.vstipocuentaid = 0;
      this.vscuentaid = 0;
      this.vsdiaid = 0;
      this.vsmesid = 0;
      this.vsañoid = 0;
      this.vsdocumentoobservacion = 0;
    },

    apaga() {
      this.vsbuscarsocio = 1;
      this.vssocioid = 1;
      this.vstipodocumentoid = 1;
      this.vstipocuentaid = 1;
      this.vscuentaid = 1;
      this.vsdiaid = 1;
      this.vsmesid = 1;
      this.vsañoid = 1;
      this.vsdocumentoobservacion = 1;
    },

    // metodo listar
    listar() {

      
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let url = "api/documentos/listar";
      axios
        .get(url, configuracion)
        .then(function (response) {
          me.documentos = response.data.documento;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    verimagenpdf(item){
      if (item.documentoextencion == 1) {
        this.imagenopdf = 1;
        this.verdocumento=this.url+item.documentoruta+"/1"
        window.open(this.verdocumento);
      }
      if (item.documentoextencion == 2) {
        this.imagenopdf = 2;
        this.verdocumento = this.url+item.documentoruta+"/2"
        window.open(this.verdocumento);
      }
    },

    eliminar(documento) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Eliminar",
                text:
                    "Movimiento: " +
                    documento.documentonombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Eliminar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/documentos/eliminar",
                            {
                                documentoid: documento.documentoid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
    },

    activar(documento) {
            let me = this;
            let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
            // Actualiza
            me.$swal({
                icon: "warning",
                title: "Estas Seguro de Activar",
                text:
                    "Movimiento: " +
                    documento.documentonombre,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Activar",
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("api/documentos/activar",
                            {
                                documentoid: documento.documentoid
                            },
                            configuracion)
                        .then(function (response) {
                            me.botonver = 1;
                            me.limpiar();
                            me.listar();
                            me.$swal("Activado", "Se a Activado con Exito", "success");
                            me.close();
                        })
                        .catch(function (error) {
                            if (error.status === 401) {
                                me.$swal("La Sesión a Expirado");
                                me.$store.dispatch("salir");
                            }
                        });
                }
            });
    },

    // Buscar socio
    buscarsocio() {
      if (this.validarexiste()) {
        return;
      }
      let me = this;
      me.alerta = null;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/socios/Selectid/" +
          this.socioid +
          "/" +
          this.$store.state.usuario.geograficoestructutaid,
          configuracion
        )
        .then(function (response) {
          //console.log(response);
          //me.agregarDetalle(response.data);
          me.alertavisible = 1;
          me.alerta = "EL SOCIO ES :" + response.data.socionombrecompleto;
        })
        .catch(function (error) {
          console.log(error);
          me.alertavisible = 0;
          me.alerta = "¡NO EXISTE EL SOCIO!";
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });


    },

    // Select
    selectempresa() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/empresas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.empresa;
          listaArray.map(function (x) {
            me.empresaselect.push({
              text: x.empresanombre,
              value: x.empresaid
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

     // Select
    selectexpediente() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/expedientes/expedienteid/"+me.carpetaid, configuracion)
        .then(function (response) {
          listaArray = response.data.expediente;
          listaArray.map(function (x) {
            me.expedienteselect.push({
              text: x.expedientenombre,
              value: x.expedienteid
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Select
    selectcarpeta() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/carpetas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.carpeta;
          listaArray.map(function (x) {
            me.carpetaselect.push({
              text: x.carpetanombre,
              value: x.carpetaid
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectempresanombre() {
      this.empresanombre = event.target.textContent;
    },

    selectcarpetanombre() {
      this.carpetanombre = event.target.textContent;
      this.selectexpediente();
    },

    listarcuentas() {
      let me = this;
      this.cuentaselect = [];
      this.cuentaselect = [{ text: "NO APLICA", value: "0" }];
      var cuentaArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/socios/ListarFiltroCuenta/" +
          this.socioid +
          "/" +
          this.tipocuentaid,
          configuracion
        )
        .then(function (response) {
          cuentaArray = response.data;
          cuentaArray.map(function (x) {
            me.cuentaselect.push({
              text:
                x.cuentaid + " - " + x.cuentanombre + " - " + x.cuentaimporte,
              value: x.cuentaid
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    editItem(item) {
      this.TablaVisible=1;
      this.imagePreview = "";
      let me = this;
      let self = this;
      this.guardarvisible = 0;
      this.empresaid = item.empresaid;
      this.carpetaid=item.carpetaid;
      this.documentonombre=item.documentonombre;
      this.documentoobservacion = item.documentoobservacion;
      this.diaid = item.documentodia;
      this.mesid = item.documentomes;
      this.añoid = item.documentoanio;

      if (item.documentoextencion == 1) {
        this.imagenopdf = 1;
        this.imagePreview=this.url+item.documentoruta+"/1"        
      }
      if (item.documentoextencion == 2) {
        this.imagenopdf = 2;
        this.pdfPreview = this.url+item.documentoruta+"/2"
      }

    },
    cancelar(item) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.$swal({
        title: "Estas Seguro de Cancelar",
        text: "No podrás revertir",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          axios
            .put(
              "api/documentos/Cancelar/" + item.documentoid,
              {},
              configuracion
            )
            .then(function (response) {
              me.limpiar();
              me.listar();
            })
            .catch(function (error) {
              console.log(error);
              if (error.response.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
            });
          this.$swal("Cancelado", "Se a Cancelado con Exito", "success");
        }
      });


    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.TablaVisible = 0;
      this.guardarvisible = 1;
      this.limpiar();
    },

    limpiar() {
      this.socioid = "";
      this.documentofecha = "";
      this.tipodocumentoid = "";
      this.documentoobservacion = "";
      this.imagePreview = "";
      this.pdfPreview = "";
      this.alerta = "";
      this.tipocuentaid = "";
      this.cuentaid = "";
      this.diaid = "";
      this.mesid = "";
      this.añoid = "";
      this.prende();
      this.alertavisible = 2;
      this.empresaid="";
      this.carpetaid="";
      this.documentonombre="";
    },

    guardar() {

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      let formData = new FormData();

      formData.append("documentonombre", me.documentonombre);
      formData.append("empresaid", me.empresaid);
      formData.append("empresanombre", me.empresanombre);
      formData.append("carpetaid", me.carpetaid);
      formData.append("carpetanombre", me.carpetanombre);
      formData.append("documentoobservacion", me.documentoobservacion);
      formData.append("usuarioid", me.$store.state.usuario.usuarioid);
      formData.append("file0", me.file);
      formData.append("documentoextencion", me.extencion);
      formData.append("documentocombustible", me.combustibleid);
      formData.append("documentofecha", me.documentofechacarga);
      formData.append("documentofolio", me.documentofolio);
      
      axios
        .post("api/documentos/crear",
        formData, configuracion)
        .then(function (response) {
          me.close();
          me.listar();
          me.limpiar();
          me.$swal("Documento Guardada con Exito");
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    validarexiste() {
      this.valida = 0;
      this.validamensaje = [];

      if (this.socioid == 0) {
        this.validamensaje.push("El Numero del Socio ests Vacio");
      }
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      this.alertavisible = 0;
      this.alerta = "¡NO EXISTE EL SOCIO!";
      return this.valida;
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (this.socioid == 0) {
        this.validamensaje.push("El Numero del Socio ests Vacio");
        this.alertavisible = 0;
        this.alerta = "¡NO EXISTE EL SOCIO!";
      }

      if (!this.tipodocumentoid) {
        this.validamensaje.push("El Tipo de Documento Esta Vacio");
      }

      if (!this.tipocuentaid) {
        this.validamensaje.push("El Tipo de Cuenta Esta Vacia");
      }

      if (!this.cuentaid) {
        this.validamensaje.push("La Cuenta Esta Vacia");
      }

      if (!this.diaid) {
        this.validamensaje.push("El Dia Esta Vacio");
      }
      if (!this.mesid) {
        this.validamensaje.push("El Mes Esta Vacio");
      }

      if (!this.añoid) {
        this.validamensaje.push("El Año Esta Vacio");
      }

      if (!this.documentoobservacion) {
        this.validamensaje.push("La Observacion Esta Vacia");
      }

      if (!this.file) {
        this.validamensaje.push("La Imagen Esta Vacio");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.apaga();
      this.socioid = item.socioid;
      this.documentofecha = item.documentofecha;
      this.documentohora = item.documentohora;
      this.tipodocumentonombre = item.tipodocumentonombre;
      this.socionombrecompleto = item.socionombrecompleto;
      this.adModal = 1;
      this.adNombre = item.tasadescripcion;
      this.adId = item.tasaid;

      if (item.documentoextencion == 1) {
        this.imagenopdf = 1;
        this.verdocumento=this.url+item.documentoruta+"/1"
        
      }
      if (item.documentoextencion == 2) {
        this.imagenopdf = 2;
        this.verdocumento = this.url+item.documentoruta+"/2"
      }
    },


     async abrirDocumentoConAxios(item) {
      this.mensajeError = null;


         let header = { Authorization: this.$store.state.token };
            let configuracion = { headers: header };
         

      try {
        // Realiza la solicitud GET a tu backend de Laravel usando Axios
        // Es crucial especificar 'responseType: "blob"' para recibir los datos binarios
        const response = await axios.get(`api/documentos/verdocumento/${item.documentoid}`, {
          responseType: 'blob', // ¡Importante para recibir archivos!
          // Si necesitas enviar headers de autenticación (ej. un token JWT), hazlo aquí:
           headers: {
             'Authorization': 'Bearer ' + this.$store.state.token,
           },
        });

        // Crea un objeto Blob a partir de los datos de la respuesta
        // El 'type' del Blob se obtiene del 'Content-Type' de los headers de la respuesta
        const blob = new Blob([response.data], { type: response.headers['content-type'] });

        // Crea una URL de objeto para el Blob
        const url = window.URL.createObjectURL(blob);

        // Abre la URL en una nueva pestaña
        const newWindow = window.open(url, '_blank');

        // Opcional: Si la ventana se bloquea (por un bloqueador de pop-ups),
        // puedes mostrar un mensaje.
        if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
          this.mensajeError = 'El navegador ha bloqueado la apertura de la nueva ventana. Por favor, permite pop-ups para este sitio.';
        }

        // Limpia la URL del objeto después de un corto tiempo o cuando la ventana se cierra
        // para liberar memoria. Puedes revocarla inmediatamente o después de un breve retraso
        // para asegurar que el navegador tenga tiempo de cargar el contenido.
        // Un enfoque más robusto podría ser escuchar el evento 'unload' de la nueva ventana,
        // pero para la mayoría de los casos, un timeout corto es suficiente.
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100); // Revoca la URL después de 100ms
      } catch (error) {
        if (error.response) {
          // El servidor respondió con un estado de error (ej. 404, 500)
          // Si tu backend Laravel devuelve un JSON en caso de error (como en tu función 'verdocumento' original),
          // intentamos leerlo.
          if (error.response.data instanceof Blob) {
            // Si la respuesta de error es un Blob (ej. un HTML de error), conviértela a texto
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result);
                this.mensajeError = errorData.message || 'Error desconocido al obtener el documento.';
              } catch (e) {
                this.mensajeError = 'Error al obtener el documento. Respuesta del servidor no pudo ser procesada.';
              }
            };
            reader.readAsText(error.response.data);
          } else {
            // Si la respuesta de error no es un Blob (ej. JSON directamente), úsala
            this.mensajeError = error.response.data.message || 'Error desconocido al obtener el documento.';
          }
        } else if (error.request) {
          // La solicitud fue hecha pero no se recibió respuesta (ej. problema de red)
          this.mensajeError = 'No se recibió respuesta del servidor. Verifica tu conexión a internet.';
        } else {
          // Algo más sucedió al configurar la solicitud
          this.mensajeError = 'Error al configurar la solicitud: ' + error.message;
        }
        console.error('Error al abrir el documento con Axios:', error);
      }
    },
  
    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    submitForm() {
      let me = this;

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("vartipotasa", this.tasatipo);

      axios
        .post(
          "api/tasas/SubirArchivos",

          formData,

          {
            headers: {
              "Content-Type": "multipart/form-data",

              Authorization: "Bearer " + this.$store.state.token,

              serie: me.serie
            }
          }
        )
        .then(function (data) {
          console.log(data.data);
        })

        .catch(function () {
          console.log("FAILURE!!");
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      //this.file = e.target.files[0];
      this.cargarImagen(file);
    },

    handleFileUpload() {
      /*
          Set the local file variable to what the user has selected.
        */
      this.file = this.$refs.file.files[0];

      /*
          Initialize a File Reader object
        */
      let reader = new FileReader();

      /*
          Add an event listener to the reader that when the file
          has been loaded, we flag the show preview as true and set the
          image to be what was read from the reader.
        */
      reader.addEventListener(
        "load",
        function () {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.imagenopdf = 1;
            this.extencion = 1;
            this.showPreview = true;
            this.imagePreview = reader.result;
          }

          if (/\.(pdf)$/i.test(this.file.name)) {
            this.imagenopdf = 2;
            this.extencion = 2;
            this.showPreview = true;
            this.pdfPreview = reader.result;
          }
        }.bind(this),
        false
      );

      

      /*
          Check to see if the file is not empty.
        */
      if (this.file) {
        /*
            Ensure the file is an image file.
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        if (/\.(pdf)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },

    cargarImagen(file) {
      let reader = new FileReader();
      reader.onload = e => {
        this.imagen = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>